import { Check } from "lucide-mui";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import TextField from "@mui/material/TextField";
import { DEFAULT_DATE_PRESETS, type DateRangeSpec, presetFrom } from "../specs.ts";

interface DateRangeEditorProps {
  spec: DateRangeSpec;
  from: string;
  to: string;
  onChange: (from: string | null, to: string | null) => void;
}

/** Quick periods ("Last 30 days") and a custom from/to. */
export default function DateRangeEditor({ spec, from, to, onChange }: DateRangeEditorProps) {
  const presets = spec.presets ?? DEFAULT_DATE_PRESETS;
  const activePreset = !to ? presets.find((p) => presetFrom(p) === from) : undefined;
  return (
    <Box>
      <MenuList>
        {presets.map((p) => {
          const selected = p === activePreset;
          return (
            <MenuItem key={p.label} selected={selected} onClick={() => onChange(selected ? null : presetFrom(p), null)}>
              <ListItemIcon sx={{ minWidth: 16 }}>{selected && <Check />}</ListItemIcon>
              <ListItemText primary={p.label} />
            </MenuItem>
          );
        })}
      </MenuList>
      <Divider />
      <Box sx={{ p: 1.5, display: "flex", gap: 1 }}>
        <TextField
          size="small"
          type="date"
          label="From"
          value={from}
          onChange={(e) => onChange(e.target.value || null, to || null)}
          slotProps={{ inputLabel: { shrink: true } }}
          sx={{ flex: 1 }}
        />
        {spec.toParam && (
          <TextField
            size="small"
            type="date"
            label="To"
            value={to}
            onChange={(e) => onChange(from || null, e.target.value || null)}
            slotProps={{ inputLabel: { shrink: true }, htmlInput: { min: from || undefined } }}
            sx={{ flex: 1 }}
          />
        )}
      </Box>
    </Box>
  );
}
